import { PureComponent } from 'react';
import { injectConfig, configShape } from '@client/hoc/config';
import { addUsabillaToWindow } from './script';

export class Usabilla extends PureComponent {
    static propTypes = {
        config: configShape.isRequired,
    }

    componentDidMount() {
        const { config } = this.props;

        if (config.isEnabled('usabilla')) {
            addUsabillaToWindow(config.usabilla);
        }
    }

    render() {
        return null;
    }
}


export default injectConfig(Usabilla);
